import { UserType } from '@bulthaup/api/db';
import { Tabs } from '@mantine/core';
import { useLocation, useNavigate, useParams } from '@tanstack/react-router';

import { useUser } from '../../../../hooks/use-user';
import classes from './header-tabs.module.css';

const commonTabs = [
  { label: 'Budget', key: 'budget' },
  { label: 'Fiche Fournisseur', key: 'fiche-fournisseur' },
  { label: 'Documents', key: 'documents' },
  { label: 'Livraison et Pose', key: 'livraison-et-pose' },
  { label: 'Client', key: 'client' },
  { label: 'Lettres', key: 'lettres' },
  { label: 'Pièces jointes', key: 'photos' },
].filter(tab => tab !== null);

const installerTabs = [
  { label: 'Accueil', key: 'poseur' },
  { label: 'Client', key: 'client' },
  { label: 'Pièces jointes', key: 'photos' },
];

export function HeaderTabs() {
  const navigate = useNavigate();
  const { slug: projectSlug } = useParams({ from: '/app/projets/$slug' });
  const { user } = useUser();

  const currentTab = useLocation().pathname.split('/').pop();

  const tabs = user?.type === UserType.INSTALLER ? installerTabs : commonTabs;

  const items = tabs.map(tab => (
    <Tabs.Tab value={tab.key} key={tab.key}>
      {tab.label}
    </Tabs.Tab>
  ));

  return (
    <div className={classes.header}>
      <Tabs
        defaultValue="Accueil"
        variant="outline"
        classNames={{
          root: classes.tabs,
          list: classes.tabsList,
          tab: classes.tab,
        }}
        value={currentTab}
        onChange={value => {
          navigate({
            to: `/app/projets/${projectSlug}/${value}`,
          });
        }}
      >
        <Tabs.List>{items}</Tabs.List>
      </Tabs>
    </div>
  );
}
